export default __webpack_public_path__ + "static/media/people-icon.1de7aba8.svg";